import { render, staticRenderFns } from "./viewWorkLeaveEmployee.vue?vue&type=template&id=6b9cbcef&scoped=true&"
import script from "./viewWorkLeaveEmployee.vue?vue&type=script&lang=js&"
export * from "./viewWorkLeaveEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cbcef",
  null
  
)

export default component.exports